import { api, type Page } from "@/lib/api/client";
import type {
  CreatePresentationRequestInput,
  MyPresentationListFilters,
  PresentationListFilters,
  PresentationRequest,
  PresentationSuggestions,
} from "./presentation-requests.types";

const BASE = "/events/presentation-requests";

/**
 * Sunum talepleri — pz-akis 6 Ekim 2026 (plan M15).
 *
 * İKİ LİSTE, İKİ SORU: `list` pazarlamanın (bütün talepler, `events.presentation.read`),
 * `mine` talebi açanın (kendi talepleri, `events.presentation.request`).
 */
export const presentationRequestsApi = {
  list(filters: PresentationListFilters): Promise<Page<PresentationRequest>> {
    return api.page<PresentationRequest>(BASE, { params: { ...filters } });
  },
  mine(filters: MyPresentationListFilters): Promise<Page<PresentationRequest>> {
    return api.page<PresentationRequest>(`${BASE}/mine`, { params: { ...filters } });
  },
  /** Onay akışında bana görev düşmüş talepler — bölge müdürünün «gelenler»i (30 Ekim 2026). */
  incoming(filters: MyPresentationListFilters): Promise<Page<PresentationRequest>> {
    return api.page<PresentationRequest>(`${BASE}/incoming`, { params: { ...filters } });
  },
  /** Formun kurum ve bölüm önerileri (30 Ekim 2026). */
  suggestions(): Promise<PresentationSuggestions> {
    return api.get<PresentationSuggestions>(`${BASE}/suggestions`);
  },
  get(id: string): Promise<PresentationRequest> {
    return api.get<PresentationRequest>(`${BASE}/${id}`);
  },
  /**
   * Açar VE onaya gönderir. Yeniden denemesi güvenli değil (ikinci bir talep, ikinci bir onay
   * süreci), bu yüzden anahtar ZORUNLU ve çağıran aynı gönderimin yeniden denemesinde AYNI
   * anahtarı vermeli — burada üretmek başlığı anlamsızlaştırırdı.
   */
  create(
    input: CreatePresentationRequestInput,
    idempotencyKey: string,
  ): Promise<PresentationRequest> {
    return api.post<PresentationRequest>(BASE, input, { idempotencyKey });
  },
  cancel(id: string, input: { version: number; reason?: string }): Promise<PresentationRequest> {
    return api.post<PresentationRequest>(`${BASE}/${id}/cancel`, input);
  },
};
